module.exports = __webpack_public_path__ + "static/Pintrest Mockup-fad4f5edcb522b14c823e4dbb23538d4.png";